import { render, staticRenderFns } from "./Jumpilla.vue?vue&type=template&id=0312fa3c&scoped=true"
import script from "./Jumpilla.vue?vue&type=script&lang=ts"
export * from "./Jumpilla.vue?vue&type=script&lang=ts"
import style0 from "./Jumpilla.vue?vue&type=style&index=0&id=0312fa3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312fa3c",
  null
  
)

export default component.exports